import React, { useEffect, Suspense } from 'react';
import Moment from 'moment';
import ReactDOM from 'react-dom';
import { NumberUtil } from '@aperza/util';
import { useTranslation } from 'react-i18next';
import { useReactiveMessage, useYouTubeInfo } from '@aperza/ui';
export const CatalogPageVideo = ({ videoId }) => {
    const { video, loadingVideoInfo, setVideoId } = useYouTubeInfo(videoId);
    const { sendMessage } = useReactiveMessage('CATALOG_VIDEO');
    const { t, i18n } = useTranslation('catalog');
    useEffect(() => {
        setVideoId(videoId);
    }, [videoId]);
    const onClickVideo = (e) => {
        e.preventDefault();
        sendMessage({ video });
    };
    return (React.createElement("div", { className: "item" },
        loadingVideoInfo && React.createElement("span", null, "LOADING"),
        !loadingVideoInfo && video != null && video !== undefined && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "thumb" },
                React.createElement("a", { href: "#", className: "js_modal modal-youtube", onClick: onClickVideo, "data-videourl": `https://www.youtube.com/embed/${video.videoId}?&autoplay=1&rel=0` },
                    React.createElement("img", { alt: video.title, src: video.thumbnailUrl }))),
            React.createElement("div", { className: "desc" },
                React.createElement("p", null,
                    React.createElement("a", { href: "#", className: "js_modal modal-youtube", onClick: onClickVideo, "data-videourl": `https://www.youtube.com/embed/${video.videoId}?&autoplay=1&rel=0` }, video.title)),
                React.createElement("p", { className: "subTxt" }, video.authorName),
                React.createElement("p", { className: "subTxt" }, `${NumberUtil.formattedNumber(video.viewCount)} ${t('catalog.video.view')} | ${Moment(video.publishedAt).locale(i18n.language).fromNow()}`),
                React.createElement("div", { className: "dtl" }, video.tags &&
                    video.tags.map((tag, i) => (React.createElement("span", { key: i, className: "badge badge-default mr-1" }, tag)))))))));
};
export const renderCatalogPageVideo = () => {
    const catalogPageVideoDivId = 'catalog-page-video-component';
    const element = document.getElementById(catalogPageVideoDivId);
    if (element) {
        ReactDOM.render(React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(CatalogPageVideo, { videoId: element.getAttribute('data-video-id') ?? undefined })), element);
    }
    else {
        console.warn(`Trying to render VideoId in Catalog Page: ${element}`);
    }
};
CatalogPageVideo.displayName = 'CatalogPageVideo';
